const steps = ['Add a new system', 'Verification by Enphase']

const applicationStatus = {
  'Site_Submitted': ['Verification Pending', '#F0D852', 1],
  'Site_Approved': ['Verification Successful', '#4ED01F', 2],
  'Site_Rejected': ['Verification Failed', '#FA2E2E', 1],
}

const SITEALREADYEXISTSERROR = 'There already exists an application with this Site ID'
const ALL = 'All'
const APPROVED = 'Approved'
const REJECTED = 'Rejected'
const PENDING = 'Pending'
const WITHDRAWN = 'Withdrawn'
const UNENROLLED = 'Unenrolled'
const INPROGRESS = 'In Progress'
const APPROVEDBYENPHASE = 'Verification Successful'//'Approved by Enphase'
const REJECTEDBYENPHASE = 'Verification Failed'//'Rejected by Enphase'
const SUBMITTEDFORREVIEW = 'Verification Pending'//'Submitted for review'
const APPLICATIONAPPROVED = 'Application_Approved'
const APPLICATIONREJECTED = 'Application_Rejected'

const SITEAPPROVED = 'Site_Approved'
const SITEREJECTED = 'Site_Rejected'
const SITESUBMITTED = 'Site_Submitted'

const SYSTEMSPENDING = 'Systems Pending'
const SYSTEMADDITION = 'System Addition'

const getDropDownValues = (page) => {
  if (page === SYSTEMSPENDING) {
    return [ALL, APPROVED, REJECTED, PENDING, WITHDRAWN, UNENROLLED, INPROGRESS]
  }
  return [ALL, SUBMITTEDFORREVIEW, APPROVEDBYENPHASE, REJECTEDBYENPHASE]
}

const getSystemsPendingHeadings = (status, page, classes, programStandardization) => ([
  ...(programStandardization || page === SYSTEMADDITION) ? [{
    id: 'siteId',
    header: 'SITE ID',
    className: classes.centerHeader
  }] : [],
  ...(page === SYSTEMADDITION ? [] : [{
    id: 'system',
    header: 'SYSTEM NAME',
  }]),
  ...(page === SYSTEMADDITION ? [{
    id: 'optionalId',
    header: 'OPTIONAL ID',
    className: classes.centerHeader
  }] : []),
  {
    id: 'applicationForm',
    header: 'APPLICATION FORM',
  },
  ...(page === SYSTEMADDITION ? [{
    id: 'homeOwnerFullName',
    header: 'HOME OWNER FULL NAME',
  }] : []),
  ...(status === ALL ? [
    {
      id: 'applicationStatus',
      header: 'APPLICATION STATUS',
      isDropdown: true,
      dropDownValues: getDropDownValues(page)
    }
  ] :
    status === APPROVED ? [
      {
        id: 'approved',
        header: 'APPROVED',
        isDropdown: true,
        dropDownValues: getDropDownValues(page)
      }
    ] :
      status === REJECTED ? [
        {
          id: 'rejected',
          header: 'REJECTED',
          isDropdown: true,
          dropDownValues: getDropDownValues(page)
        }
      ] :
        status === WITHDRAWN ? [
          {
            id: 'withdrawn',
            header: 'WITHDRAWN',
            isDropdown: true,
            dropDownValues: getDropDownValues(page)
          }
        ] :
          status === UNENROLLED ? [
            {
              id: 'unenrolled',
              header: 'UNENROLLED',
              isDropdown: true,
              dropDownValues: getDropDownValues(page)
            }
          ] :
            status === APPROVEDBYENPHASE ? [
              {
                id: 'approvedByEnphase',
                header: 'VERIFICATION SUCCESSFUL',
                isDropdown: true,
                dropDownValues: getDropDownValues(page)
              }
            ] :
              status === REJECTEDBYENPHASE ? [
                {
                  id: 'rejectedByEnphase',
                  header: 'VERIFICATION FAILED',
                  isDropdown: true,
                  dropDownValues: getDropDownValues(page)
                }
              ] :
                status === SUBMITTEDFORREVIEW ? [
                  {
                    id: 'submittedForReview',
                    header: 'VERIFICATION PENDING',
                    isDropdown: true,
                    dropDownValues: getDropDownValues(page)
                  }
                ] :
                  status === INPROGRESS ? [
                    {
                      id: 'inProgress',
                      header: 'IN PROGRESS',
                      isDropdown: true,
                      dropDownValues: getDropDownValues(page)
                    }
                  ] : 
                    [
                      {
                        id: 'pending',
                        header: 'PENDING',
                        isDropdown: true,
                        dropDownValues: getDropDownValues(page)
                      }
                    ]
  )
])

export {
  steps,
  SITEALREADYEXISTSERROR,
  ALL,
  APPROVED,
  REJECTED,
  APPROVEDBYENPHASE,
  REJECTEDBYENPHASE,
  SUBMITTEDFORREVIEW,
  SYSTEMSPENDING,
  SYSTEMADDITION,
  APPLICATIONAPPROVED,
  APPLICATIONREJECTED,
  SITEAPPROVED,
  SITEREJECTED,
  SITESUBMITTED,
  applicationStatus,
  getSystemsPendingHeadings
}